/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitCreditApplication_submitCreditApplication_CreditApplication_validationErrors_CreditApplicationValidationError = { readonly __typename: 'CreditApplicationValidationError', readonly path: string | null, readonly error: string | null };

export type SubmitCreditApplication_submitCreditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly validationErrors: ReadonlyArray<SubmitCreditApplication_submitCreditApplication_CreditApplication_validationErrors_CreditApplicationValidationError | null> | null };

export type SubmitCreditApplication_Mutation = { readonly __typename: 'Mutation', readonly submitCreditApplication: SubmitCreditApplication_submitCreditApplication_CreditApplication };


export type SubmitCreditApplicationVariables = _Types.Exact<{
  creditTerms: _Types.Scalars['Boolean']['input'];
  creditApplicationId: _Types.Scalars['ID']['input'];
  creditApplicationFetchedAt: _Types.Scalars['NaiveDateTime']['input'];
  fraudPreventionData?: _Types.InputMaybe<_Types.Scalars['String']['input']>;
  clientTimeZone?: _Types.InputMaybe<_Types.Scalars['String']['input']>;
}>;


export type SubmitCreditApplication = SubmitCreditApplication_Mutation;


export const SubmitCreditApplicationDocument = gql`
    mutation SubmitCreditApplication($creditTerms: Boolean!, $creditApplicationId: ID!, $creditApplicationFetchedAt: NaiveDateTime!, $fraudPreventionData: String, $clientTimeZone: String) {
  submitCreditApplication(
    creditTerms: $creditTerms
    creditApplicationId: $creditApplicationId
    creditApplicationFetchedAt: $creditApplicationFetchedAt
    fraudPreventionData: $fraudPreventionData
    clientTimeZone: $clientTimeZone
  ) {
    salesforceCreditId
    validationErrors {
      path
      error
    }
  }
}
    `;
export type SubmitCreditApplicationMutationFn = Apollo.MutationFunction<SubmitCreditApplication, SubmitCreditApplicationVariables>;

/**
 * __useSubmitCreditApplication__
 *
 * To run a mutation, you first call `useSubmitCreditApplication` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCreditApplication` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCreditApplication, { data, loading, error }] = useSubmitCreditApplication({
 *   variables: {
 *      creditTerms: // value for 'creditTerms'
 *      creditApplicationId: // value for 'creditApplicationId'
 *      creditApplicationFetchedAt: // value for 'creditApplicationFetchedAt'
 *      fraudPreventionData: // value for 'fraudPreventionData'
 *      clientTimeZone: // value for 'clientTimeZone'
 *   },
 * });
 */
export function useSubmitCreditApplication(baseOptions?: Apollo.MutationHookOptions<SubmitCreditApplication, SubmitCreditApplicationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCreditApplication, SubmitCreditApplicationVariables>(SubmitCreditApplicationDocument, options);
      }
export type SubmitCreditApplicationHookResult = ReturnType<typeof useSubmitCreditApplication>;
export type SubmitCreditApplicationMutationResult = Apollo.MutationResult<SubmitCreditApplication>;
export type SubmitCreditApplicationMutationOptions = Apollo.BaseMutationOptions<SubmitCreditApplication, SubmitCreditApplicationVariables>;